import Delete from "@mui/icons-material/Delete";
import Grid2 from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getFieldPath } from "../../Common/SchemaUtils";

const CurrencyFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  remove?: Function;
}> = ({ extractionId, extractionPath, remove }) => {
  const { control } = useFormContext();

  const amountPath = `extraction.${getFieldPath([
    extractionId,
    "value",
    extractionPath,
  ])}.value`;
  const currencyPath = `extraction.${getFieldPath([
    extractionId,
    "value",
    extractionPath,
  ])}.currency`;

  return (
    <Grid2
      container
      spacing={2}
      key={getFieldPath([extractionId, extractionPath])}
      sx={{ alignItems: "flex-end" }}
    >
      <Grid2 size={remove !== undefined ? 11 : 12} sx={{ display: "flex" }}>
        <Controller
          name={amountPath}
          control={control}
          render={({ field: amountField, fieldState: { error } }) => (
            <TextField
              {...amountField}
              size="small"
              label="Montant"
              type="number"
              variant="outlined"
              fullWidth
              error={!!error}
              helperText={error?.message}
              onChange={(e) => {
                const numericValue = Number(e.target.value);
                amountField.onChange(
                  isNaN(numericValue) ? e.target.value : numericValue
                );
              }}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="start" sx={{ mr: -1 }}>
                      <Controller
                        name={currencyPath}
                        control={control}
                        render={({ field: currencyField }) => (
                          <TextField
                            {...currencyField}
                            size="small"
                            variant="standard"
                            placeholder="Devise"
                            sx={{
                              "& .MuiInput-underline:before": {
                                borderBottom: "none",
                              },
                              "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                { borderBottom: "none" },
                              "& .MuiInput-underline:after": {
                                borderBottom: "none",
                              },
                              borderTopLeftRadius: 0,
                              borderBottomLeftRadius: 0,
                              borderLeft: "1px solid #e0e0e0",
                              marginLeft: 1,
                            }}
                            value={currencyField.value || ""}
                            slotProps={{
                              htmlInput: { style: { textAlign: "center" } },
                            }}
                            onChange={(e) =>
                              currencyField.onChange(e.target.value)
                            }
                          />
                        )}
                      />
                    </InputAdornment>
                  ),
                },
              }}
            />
          )}
        />
      </Grid2>
      {remove !== undefined && (
        <Grid2 size={1} sx={{ textAlign: "center", pb: 0.5 }}>
          <IconButton
            onClick={() => {
              remove && remove();
            }}
            className="rounded-full"
            size="small"
          >
            <Delete color="error" />
          </IconButton>
        </Grid2>
      )}
    </Grid2>
  );
};

export default CurrencyFormFields;
